/*jshint esversion: 6 */
// or .jshintrc for all jsx-files

import React from 'react';

import * as THREE from 'three';

//import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

import ktrlogo from './ktrlogo.png'


/*
const styles = theme => ({
    page: theme.aside.page,
    aside: theme.aside.aside,
    body: {
        ...theme.aside.body,
        minHeight: 'initial',
        height: 'calc(100% - 81px)',
    },
    canvas: {
        height: '100%',
        width: '100%',
    }
});
*/


interface IProps {
    material: string,
    model: string,
    helpbox: any,
}

interface IState {
    texture?: THREE.Texture,
    material?: THREE.Material,
    materialsLibrary: { [id: string] : THREE.Material },
    showActivateBanner: boolean,
}


// ====================================================================================================================================
class Model3D extends React.Component<IProps, IState> {
    scene: THREE.Scene;
    //container: any;
    camera: THREE.PerspectiveCamera;
    renderer: THREE.WebGLRenderer;
    meshBox: THREE.Mesh | undefined;
    meshCooler: THREE.Mesh | undefined;

    rotateMeshCooler: boolean;

    private divRef: React.RefObject<HTMLDivElement>;

    // --------------------------------------------------------------------------------------------------------------------------------
    constructor(props: IProps) {
        super(props);

        this.state = {
            texture: undefined,
            material: undefined,
            materialsLibrary: {},
            showActivateBanner: true,
        }

        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera();
        this.renderer = new THREE.WebGLRenderer();
        this.meshCooler = undefined;

        this.divRef = React.createRef<HTMLDivElement>();

        this.rotateMeshCooler = true;
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    componentDidMount = () => {
        //this.loadTexture().then (
        //    t => this.setState( { texture: t as THREE.Texture } )
        //);

        let mLib = this.createMaterialsLibrary();
        this.setState( { materialsLibrary: mLib } );

        //if (this.state.texture !== null) {
            this.init();
        //}

    }

    // --------------------------------------------------------------------------------------------------------------------------------
    componentDidUpdate = () => {
        //if (this.state.texture !== null) {
//            this.init();
        //}
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    loadTexture = () => {
        return new Promise(async (s, r) => {
            const textureLoader = new THREE.TextureLoader();
            var pathToTexture = process.env.PUBLIC_URL + "/models/sinter.jpg";
            let t = await textureLoader.load(pathToTexture);
            s(t)
        })
    }

    setTexture = (m: THREE.MeshBasicMaterial) => {
        const texture: THREE.Texture | undefined = this.state.texture;
        if(texture !== undefined) {
            texture.encoding = THREE.sRGBEncoding;
            texture.anisotropy = 16;
            m.map = texture;
        }
    }

    loadSTL = (pathToModel: string) => {
        return new Promise(resolve => {
          new STLLoader().load(pathToModel, resolve);
        });
    }

    //loadOBJ = (pathToModel: string) => {
    //    return new Promise(resolve => {
    //      new OBJLoader().load(pathToModel, resolve);
    //    });
    //}

    // --------------------------------------------------------------------------------------------------------------------------------
    createCoordSystem = () => {
      var axis = new THREE.AxesHelper(200);
      this.scene.add(axis);
    }

    // -------------------------------------------------------------------------------------------------
    createBottomPlane = () => {
      var grid = new THREE.GridHelper(10000.0, 500.0, 0xffffff, 0xaaaaaa);
      this.scene.add(grid);
    }

    // --------------------------------------------------------------------------------------------------------------------------------
    createMaterialsLibrary = () => {
        var mlib: { [id: string] : THREE.Material } = {};

        mlib["Hidden Line"]     = new THREE.MeshBasicMaterial( { color: 0xff6600,  } );
        mlib["Simple Green"]    = new THREE.MeshBasicMaterial( { color: 0x00aa00,  } );
        mlib["Simple Red"]      = new THREE.MeshBasicMaterial( { color: 0xaa0000,  } );
        mlib["Simple Blue"]     = new THREE.MeshBasicMaterial( { color: 0x0000aa,  } );
        mlib["Orange"]  	    = new THREE.MeshLambertMaterial( { color: 0xff6600, emissive: 0xff2200, combine: THREE.MixOperation, reflectivity: 0.3 } );
        mlib["Blue"]            = new THREE.MeshLambertMaterial( { color: 0x001133, emissive: 0x001133, combine: THREE.MixOperation, reflectivity: 0.3 } );
        mlib["Red"]             = new THREE.MeshLambertMaterial( { color: 0x660000, emissive: 0x330000, combine: THREE.MixOperation, reflectivity: 0.25 } );
        mlib["Black"]           = new THREE.MeshLambertMaterial( { color: 0x000000, emissive: 0x000000, combine: THREE.MixOperation, reflectivity: 0.15 } );
        mlib["White"]           = new THREE.MeshLambertMaterial( { color: 0xffffff, emissive: 0x666666, combine: THREE.MixOperation, reflectivity: 0.25 } );
        mlib["Carmine"]         = new THREE.MeshPhongMaterial( { color: 0x770000, specular:0xffaaaa, combine: THREE.MultiplyOperation } );
        mlib["Gold"]            = new THREE.MeshPhongMaterial( { color: 0xaa9944, specular:0xbbaa99, shininess:50, combine: THREE.MultiplyOperation } );
        mlib["Bronze"]          = new THREE.MeshPhongMaterial( { color: 0x150505, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );

        //mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xE6C2AB, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );
        //mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xB49189, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );
        //mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xB49189, specular:0xee6600, shininess:5, combine: THREE.MixOperation, reflectivity: 0.15} );
        mlib["Copper"]          = new THREE.MeshPhongMaterial( { color: 0xEBB2A5, specular:0xee6600, shininess:10, combine: THREE.MixOperation, reflectivity: 0.25 } );
        //mlib["Texture"]         = new THREE.MeshStandardMaterial( {map: this.state.texture, } );

        mlib["Chrome"]          = new THREE.MeshPhongMaterial( { color: 0xffffff, specular:0xffffff, combine: THREE.MultiplyOperation } );
        mlib["Orange metal"]    = new THREE.MeshLambertMaterial( { color: 0xff6600, emissive: 0xff2200, combine: THREE.MultiplyOperation } );
        mlib["Blue metal"]      = new THREE.MeshLambertMaterial( { color: 0x001133, emissive: 0x002266, combine: THREE.MultiplyOperation } );
        mlib["Red metal"]       = new THREE.MeshLambertMaterial( { color: 0x770000, combine: THREE.MultiplyOperation } );
        mlib["Green metal"]     = new THREE.MeshLambertMaterial( { color: 0x007711, combine: THREE.MultiplyOperation } );
        mlib["Black metal"]     = new THREE.MeshLambertMaterial( { color: 0x222222, combine: THREE.MultiplyOperation } );
        mlib["Pure chrome"]     = new THREE.MeshLambertMaterial( { color: 0xffffff } );
        mlib["Dark chrome"]     = new THREE.MeshLambertMaterial( { color: 0x444444 } );
        mlib["Darker chrome"]   = new THREE.MeshLambertMaterial( { color: 0x222222 } );
        mlib["Black glass"]     = new THREE.MeshLambertMaterial( { color: 0x101016, opacity: 0.975, transparent: true } );
        mlib["Dark glass"]      = new THREE.MeshLambertMaterial( { color: 0x101046, opacity: 0.25, transparent: true } );
        mlib["Blue glass"]      = new THREE.MeshLambertMaterial( { color: 0x668899, opacity: 0.75, transparent: true } );
        mlib["Light glass"]     = new THREE.MeshBasicMaterial( { color: 0x223344, opacity: 0.25, transparent: true, combine: THREE.MixOperation, reflectivity: 0.25 } );
        mlib["Red glass"]       = new THREE.MeshLambertMaterial( { color: 0xff0000, opacity: 0.75, transparent: true } );
        mlib["Yellow glass"]    = new THREE.MeshLambertMaterial( { color: 0xffffaa, opacity: 0.75, transparent: true } );
        mlib["Orange glass"]    = new THREE.MeshLambertMaterial( { color: 0x995500, opacity: 0.75, transparent: true } );
        mlib["Orange glass 50"] = new THREE.MeshLambertMaterial( { color: 0xffbb00, opacity: 0.5, transparent: true } );
        mlib["Red glass 50"]    = new THREE.MeshLambertMaterial( { color: 0xff0000, opacity: 0.5, transparent: true } );
        mlib["Fullblack rough"] = new THREE.MeshLambertMaterial( { color: 0x000000 } );
        mlib["Black rough"]     = new THREE.MeshLambertMaterial( { color: 0x050505 } );
        mlib["Darkgray rough"]  = new THREE.MeshLambertMaterial( { color: 0x090909 } );
        mlib["Red rough"]       = new THREE.MeshLambertMaterial( { color: 0x330500 } );
        mlib["Darkgray shiny"]  = new THREE.MeshPhongMaterial( { color: 0x000000, specular: 0x050505 } );
        mlib["Gray shiny"]      = new THREE.MeshPhongMaterial( { color: 0x050505, shininess: 20 } );

        return mlib;
    }

    createLights = () => {
        let light = new THREE.DirectionalLight(0xffffff, 0.5);
        light.position.set(-100, -100, -100);
        this.scene.add(light);

        let light1 = new THREE.DirectionalLight(0xaaaaaa);
        light.position.set(-1, -1, -1);
        this.scene.add(light1);

        let light2 = new THREE.AmbientLight(0x222222);
        this.scene.add(light2);

        const light3 = new THREE.DirectionalLight(0xffffff, 0.25);
        light3.position.set(100, 100, 100);
        this.scene.add(light3);
    }

/*
    createTestBoxAndTextureAndLight = () => {
        // --------------------------------------------------------------
        // TEST START
        const geometry = new THREE.BoxBufferGeometry(100, 100, 100);
        const texture: THREE.Texture | undefined = this.state.texture;
        if(texture !== undefined) {
            texture.encoding = THREE.sRGBEncoding;
            texture.anisotropy = 16;
            const m = new THREE.MeshStandardMaterial( {
                map: texture,
            } );
            this.meshBox = new THREE.Mesh(geometry, m);

            //this.setState({ material: m });  // init will be called in componentWillUpdate which will be called ben setState happens: inifite loop !!!

            //
            //const light = new THREE.DirectionalLight(0xffffff, 5.0);
            //light.position.set(10, 10, 10);
            //scene.add(light);

            this.scene.add(this.meshBox);
        }
        // TEST END
    }
*/

    // --------------------------------------------------------------------------------------------------------------------------------
    init = () => {
        // --------------------------------------------------------------
        this.scene.background = new THREE.Color(0x808080);

        let w = window.innerWidth;
        let h = window.innerHeight;
        if(this.divRef.current != null) {
          w = this.divRef.current?.clientWidth;
          h = this.divRef.current?.clientWidth;
        }

        const fov = 35;
        const aspect = w / h;
        const near = 0.1;
        const far = 10000;

        // --------------------------------------------------------------
        this.camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
        this.camera.position.x = 800;   // 1255;  // 0;
        this.camera.position.y = 500;   // 568;   // 300;
        this.camera.position.z = 400;   // 789;   // 1800;
        this.camera.up.x = 0;
        this.camera.up.y = 1;
        this.camera.up.z = 0;
        this.camera.lookAt(new THREE.Vector3(0, 0, 0));


        // --------------------------------------------------------------
        // TEST TEST TEST
        //this.createTestBoxAndTextureAndLight();

        // --------------------------------------------------------------
        this.createLights();

        // --------------------------------------------------------------
        let materialName: string = this.props.material;
        let modelName: string = this.props.model;
        
        let pathToModel = process.env.PUBLIC_URL + "/models/" + modelName + ".stl";

        //this.loadModel(pathToModel, this.state.materialsLibrary[materialName], 'STL');
        this.loadSTL(pathToModel).then(geometry => {
                this.meshCooler = new THREE.Mesh(geometry as any, this.state.materialsLibrary[materialName]);
                //this.setTexture(this.meshCooler.material as THREE.MeshBasicMaterial);
                this.scene.add(this.meshCooler);

                /*
                const texture: THREE.Texture | undefined = this.state.texture;
                if(texture !== undefined) {
                    texture.encoding = THREE.sRGBEncoding;
                    texture.anisotropy = 16;

                    var m = new THREE.MeshPhongMaterial( {
                        map: texture,
                        color: Math.random() * 0xffffff
                    } );
                    let mesh = new THREE.Mesh(geometry as any, m);

                    this.scene.add(mesh);
                }
                else {
                    let mesh = new THREE.Mesh(geometry as any, this.state.materialsLibrary[materialName]);
                    this.scene.add(mesh);
                }
                */
            }
        );

        // --------------------------------------------------------------
        //this.createCoordSystem();
        //this.createBottomPlane();

        // --------------------------------------------------------------
        this.renderer.setSize(w, h );
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setClearColor(0xffffff, 1.0);
        this.divRef.current?.appendChild(this.renderer.domElement);

        // --------------------------------------------------------------
        var controls = new OrbitControls(this.camera, this.renderer.domElement);
        controls.addEventListener('change', this.orbitalControlsChangeEventHandler);

        // --------------------------------------------------------------
        this.renderer.setAnimationLoop( () => {
            this.update();
            this.render3D();
        })
    }

    orbitalControlsChangeEventHandler = () => {
        this.rotateMeshCooler = false;
    }

    update = () => {
        if(this.meshCooler !== undefined && this.rotateMeshCooler === true) {
            //this.meshCooler.rotation.z += 0.01;
            //this.meshCooler.rotation.x += 0.01;
            this.meshCooler.rotation.y += 0.01;
        }
    }
    
    render3D = () => {
        this.renderer.render(this.scene, this.camera);
    }


    handleOnMouseEnter = (e:any) => {
        this.setState( { showActivateBanner: false } );
    }
    

    // --------------------------------------------------------------------------------------------------------------------------------
    render = () => {
        return (
            <div style={{position: "relative"}}>
                <div ref={this.divRef} onMouseEnter={this.handleOnMouseEnter}></div>

                {this.props.helpbox !== undefined ?
                    <div style={{display: "inline-block", position: "absolute", bottom: "0", left: "0", color: "white"}}>
                        {this.props.helpbox}
                    </div>
                    : ""
                }

                <div style={{position: "absolute", top: "0", right: "0"}}>
                    <img src={ktrlogo} alt="KTR" />
                </div>

{/*
                <div style={{display: "inline-block", position: "absolute", top: "0", right: "0"}}>
                    <img src={ktrlogo} alt="KTR" />
                </div>
*/}

                {this.state.showActivateBanner === true ?
                    <div onMouseEnter={this.handleOnMouseEnter} style={{position: "absolute", top:"40%", left:"13%", color: "#F29400", fontSize: "36px", fontWeight:"bold", zIndex:100}}>
                        Click here to activate
                    </div>
                    : ""
                }
            </div>
        )
    }    
}

//export default withStyles(styles)(Model3D);
export default (Model3D);
